import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../../../services/axiosInstance";
import { AppContext } from "../../../../services/AuthContext";
import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf";
import * as pdfjsLib from "pdfjs-dist";
import Spinner from "react-bootstrap/Spinner";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import { use } from "react";
import jsPDF from "jspdf";
import { ToastContainer, toast } from 'react-toastify';
import { getPdfAlerts } from "../../../../services/directusService";
import 'react-toastify/dist/ReactToastify.css';
import {
  // getByPublicationIdAndUserIdAndPage, 
  createPublicationPdfLog, //hata verse de geç
  createPublicationPdfLogRange,
  setVisitedPageLog
} from "../../../../services/publicationanduserpagelogService";
import { publicationBookMarkList } from "../../../../services/publicationService";
import { pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNot } from "../../../../services/publicationService";
import usePageTracking from "../../../../hooks/usePageTracking";
import { left } from "@popperjs/core";




GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// Helper to normalize broken Turkish characters/diacritics in PDF text extraction
const cleanTurkishPDFText = (str) => {
  if (!str) return str;
  let normalized = str;

  // Standard Unicode normalization (NFC) merges typical combining characters
  normalized = normalized.normalize("NFC");

  // Custom regex to handle reversed/spaced diacritics common in PDF generation
  // Cedilla (ş, Ş, ç, Ç)
  normalized = normalized.replace(/\s*[\u0327\u00B8¸]\s*([sS])/g, (m, char) => char === 'S' ? 'Ş' : 'ş');
  normalized = normalized.replace(/([sS])\s*[\u0327\u00B8¸]/g, (m, char) => char === 'S' ? 'Ş' : 'ş');
  normalized = normalized.replace(/\s*[\u0327\u00B8¸]\s*([cC])/g, (m, char) => char === 'C' ? 'Ç' : 'ç');
  normalized = normalized.replace(/([cC])\s*[\u0327\u00B8¸]/g, (m, char) => char === 'C' ? 'Ç' : 'ç');

  // Breve (ğ, Ğ)
  normalized = normalized.replace(/\s*[\u0306\u02D8˘]\s*([gG])/g, (m, char) => char === 'G' ? 'Ğ' : 'ğ');
  normalized = normalized.replace(/([gG])\s*[\u0306\u02D8˘]/g, (m, char) => char === 'G' ? 'Ğ' : 'ğ');

  // Umlaut (ö, Ö, ü, Ü)
  normalized = normalized.replace(/\s*[\u0308]\s*([oO])/g, (m, char) => char === 'O' ? 'Ö' : 'ö');
  normalized = normalized.replace(/([oO])\s*[\u0308]/g, (m, char) => char === 'O' ? 'Ö' : 'ö');
  normalized = normalized.replace(/\s*[\u0308]\s*([uU])/g, (m, char) => char === 'U' ? 'Ü' : 'ü');
  normalized = normalized.replace(/([uU])\s*[\u0308]/g, (m, char) => char === 'U' ? 'Ü' : 'ü');

  // Dotted I / Dotless I correction
  normalized = normalized.replace(/([iI])\s*[\u0307]/g, 'i');
  normalized = normalized.replace(/\s*[\u0307]\s*([iI])/g, 'i');

  return normalized;
};

// Check if a base letter is valid for a given diacritic accent
const isValidBaseCharForDiacritic = (char, diacritic) => {
  const cleanChar = char.toLowerCase();
  const cleanDia = diacritic.trim();
  
  const isCedilla = cleanDia === '̧' || cleanDia === '¸' || cleanDia === '\u0327' || cleanDia === '\u00B8';
  const isBreve = cleanDia === '̆' || cleanDia === '˘' || cleanDia === '\u0306' || cleanDia === '\u02D8';
  const isUmlaut = cleanDia === '̈' || cleanDia === '\u0308';
  const isDot = cleanDia === '̇' || cleanDia === '\u0307';
  
  if (isCedilla) {
    return cleanChar === 's' || cleanChar === 'c';
  }
  if (isBreve) {
    return cleanChar === 'g';
  }
  if (isUmlaut) {
    return cleanChar === 'o' || cleanChar === 'u';
  }
  if (isDot) {
    return cleanChar === 'i';
  }
  return false;
};

// Merge separate diacritic items and discard layout space items preceding them
const mergeTurkishDiacritics = (items) => {
  if (!items) return [];
  const mutableItems = items.map((item) => ({ ...item }));
  const result = [];
  
  const isDiacritic = (s) => {
    if (!s) return false;
    const clean = s.trim();
    return clean === '̧' || clean === '¸' || clean === '̆' || clean === '˘' || clean === '̈' || clean === '̇' ||
           clean === '\u0327' || clean === '\u00B8' || clean === '\u0306' || clean === '\u02D8' || clean === '\u0308' || clean === '\u0307';
  };
  
  for (let i = 0; i < mutableItems.length; i++) {
    const current = mutableItems[i];
    if (!current) continue;
    
    // 1. Boundary merge: Current string ends with a diacritic, next string starts with base character
    const trailingDiacriticRegex = /(\s*)((?:[\u00B8¸\u02D8˘]|\u0327|\u0306|\u0308|\u0307))$/;
    const matchTrailing = current.str.match(trailingDiacriticRegex);
    if (matchTrailing) {
      const diacritic = matchTrailing[2];
      const next = mutableItems[i + 1];
      if (next && next.str && next.str.length > 0) {
        const firstChar = next.str[0];
        if (isValidBaseCharForDiacritic(firstChar, diacritic)) {
          const combined = cleanTurkishPDFText(diacritic + firstChar);
          if (combined.length === 1) {
            current.str = current.str.slice(0, -matchTrailing[0].length);
            next.str = combined + next.str.slice(1);
            result.push(current);
            continue;
          }
        }
      }
    }
    
    // 2. Boundary merge: Current string ends with base character, next string starts with diacritic
    const leadingDiacriticRegex = /^(\s*)((?:[\u00B8¸\u02D8˘]|\u0327|\u0306|\u0308|\u0307))/;
    const next = mutableItems[i + 1];
    if (next && next.str) {
      const matchLeading = next.str.match(leadingDiacriticRegex);
      if (matchLeading) {
        const diacritic = matchLeading[2];
        const lastChar = current.str[current.str.length - 1];
        if (lastChar && isValidBaseCharForDiacritic(lastChar, diacritic)) {
          const combined = cleanTurkishPDFText(lastChar + diacritic);
          if (combined.length === 1) {
            current.str = current.str.slice(0, -1) + combined;
            next.str = next.str.slice(matchLeading[0].length);
          }
        }
      }
    }

    // 3. Fallback: Discard standalone layout spaces immediately preceding a diacritic item
    if (current.str === " ") {
      const nextItem = mutableItems[i + 1];
      if (nextItem && isDiacritic(nextItem.str)) {
        continue;
      }
    }
    
    // 4. Fallback: Standalone diacritic item merging
    const str = current.str;
    if (isDiacritic(str)) {
      // previous item
      const prev = result[result.length - 1];
      if (prev && prev.str && prev.str.length > 0) {
        const lastChar = prev.str[prev.str.length - 1];
        if (isValidBaseCharForDiacritic(lastChar, str)) {
          const combined = cleanTurkishPDFText(lastChar + str);
          if (combined.length === 1) {
            prev.str = prev.str.slice(0, -1) + combined;
            continue;
          }
        }
      }
      
      // next item
      const nextItem = mutableItems[i + 1];
      if (nextItem && nextItem.str && nextItem.str.length > 0) {
        const firstChar = nextItem.str[0];
        if (isValidBaseCharForDiacritic(firstChar, str)) {
          const combined = cleanTurkishPDFText(str + firstChar);
          if (combined.length === 1) {
            nextItem.str = combined + nextItem.str.slice(1);
            continue;
          }
        }
      }
    }
    
    result.push(current);
  }
  
  return result.filter(item => item.str !== "");
};

// --- PDFPage Component (Lazy Rendered with Search Highlight) ---
const PDFPage = ({ pageNumber, pdfDoc, zoomLevel, rotation, searchTerm, onVisible, isDarkMode }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const textLayerRef = useRef(null);
  const [page, setPage] = useState(null);
  const [viewport, setViewport] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [renderStatus, setRenderStatus] = useState("idle"); // "idle", "rendering", "rendered", "error"
  const renderTaskRef = useRef(null);

  // Intersection Observer to detect visibility (Preload pages within 400px)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: "400px 0px",
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [pageNumber]);

  // Separate Observer for Active Page Tracking (Triggered when page is centered in viewport)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onVisible(pageNumber);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "-45% 0px -45% 0px", // Middle 10% vertical slice of screen
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [pageNumber, onVisible]);

  // Fetch page details and standard viewport
  useEffect(() => {
    let active = true;
    const loadPage = async () => {
      try {
        const pageObj = await pdfDoc.getPage(pageNumber);
        if (!active) return;
        setPage(pageObj);
        const vp = pageObj.getViewport({ scale: 1 });
        setViewport(vp);
      } catch (err) {
        console.error(`Error loading page ${pageNumber}:`, err);
      }
    };
    loadPage();
    return () => {
      active = false;
    };
  }, [pdfDoc, pageNumber]);

  // Render to canvas
  useEffect(() => {
    if (!isVisible || !page || !viewport || !canvasRef.current) {
      // Clear canvas when out of view to save browser memory
      if (!isVisible && renderStatus === "rendered" && canvasRef.current) {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        if (context) {
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
        if (textLayerRef.current) {
          textLayerRef.current.innerHTML = "";
        }
        setRenderStatus("idle");
      }
      return;
    }

    const render = async () => {
      if (renderTaskRef.current) {
        renderTaskRef.current.cancel();
      }

      setRenderStatus("rendering");
      try {
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        // Set higher quality rendering based on device pixel ratio
        const outputScale = window.devicePixelRatio || 1;
        const scale = zoomLevel * outputScale * 1.5;
        const vp = page.getViewport({ scale, rotation });

        canvas.width = vp.width;
        canvas.height = vp.height;

        const renderContext = {
          canvasContext: context,
          viewport: vp,
        };

        const renderTask = page.render(renderContext);
        renderTaskRef.current = renderTask;
        await renderTask.promise;

        // Draw Search Highlights if active (utilizing merged Turkish diacritics)
        if (searchTerm && searchTerm.length >= 3) {
          const textContent = await page.getTextContent();
          const mergedItems = mergeTurkishDiacritics(textContent.items);
          const termLower = searchTerm.toLocaleLowerCase('tr-TR');

          context.save();

          mergedItems.forEach((item) => {
            const itemText = item.str;
            const itemTextLower = itemText.toLocaleLowerCase('tr-TR');

            let startIndex = 0;
            while ((startIndex = itemTextLower.indexOf(termLower, startIndex)) !== -1) {
              const tx = pdfjsLib.Util.transform(vp.transform, item.transform);
              const fontSize = Math.sqrt(tx[0] ** 2 + tx[1] ** 2);
              context.font = `${fontSize}px sans-serif`;

              const textBefore = itemText.substring(0, startIndex);
              const textMatch = itemText.substring(startIndex, startIndex + searchTerm.length);

              const prefixWidth = context.measureText(textBefore).width;
              const matchWidth = context.measureText(textMatch).width;

              context.fillStyle = "rgba(255, 255, 0, 0.4)";
              context.fillRect(
                tx[4] + prefixWidth,
                tx[5] - fontSize,
                matchWidth,
                fontSize
              );

              startIndex += termLower.length;
            }
          });
          context.restore();
        }

        // Render Text Layer for Text Selection
        const textLayerDiv = textLayerRef.current;
        if (textLayerDiv) {
          textLayerDiv.innerHTML = "";
          const textViewport = page.getViewport({ scale: zoomLevel, rotation });
          const textContent = await page.getTextContent();
          textContent.items = mergeTurkishDiacritics(textContent.items);

          await pdfjsLib.renderTextLayer({
            textContent,
            container: textLayerDiv,
            viewport: textViewport,
            textDivs: [],
          }).promise;
        }

        setRenderStatus("rendered");
      } catch (err) {
        if (err.name !== "RenderingCancelledException") {
          console.error(`Error rendering page ${pageNumber}:`, err);
          setRenderStatus("error");
        }
      }
    };

    render();

    return () => {
      if (renderTaskRef.current) {
        renderTaskRef.current.cancel();
      }
    };
  }, [isVisible, page, viewport, zoomLevel, rotation, searchTerm]);

  const ratio = viewport ? viewport.height / viewport.width : 1.414;
  const containerStyle = {
    position: "relative",
    width: "100%",
    maxWidth: viewport ? `${viewport.width * zoomLevel}px` : "800px",
    margin: "18px auto",
    backgroundColor: isDarkMode ? "#1e1e24" : "#fff",
    boxShadow: isDarkMode ? "0 4px 16px rgba(0,0,0,0.6)" : "0 4px 12px rgba(0,0,0,0.18)",
    borderRadius: "4px",
    aspectRatio: `1 / ${ratio}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "max-width 0.2s ease-out, background-color 0.3s ease",
    scrollMarginTop: "85px",
  };

  return (
    <div ref={containerRef} style={containerStyle} id={`pdf-page-${pageNumber}`}>
      {renderStatus !== "rendered" && (
        <div className="position-absolute d-flex flex-column align-items-center justify-content-center">
          <Spinner animation="border" variant="success" size="sm" />
        </div>
      )}
      <canvas
        ref={canvasRef}
        style={{
          width: "100%",
          height: "100%",
          display: renderStatus === "rendered" ? "block" : "none",
          borderRadius: "4px",
          filter: isDarkMode ? "invert(0.92) hue-rotate(180deg)" : "none",
          transition: "filter 0.3s ease",
        }}
      />
      {viewport && (
        <div
          ref={textLayerRef}
          className="textLayer"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: "auto",
            display: renderStatus === "rendered" ? "block" : "none",
          }}
        />
      )}
    </div>
  );
};

const PDFViewer = () => {
  usePageTracking("view/pdf-protected");
  const navigate = useNavigate();
  const location = useLocation();
  const autoDownloadHandledRef = useRef(false);

  const { slug } = useParams(); // URL'den slug'ı alıyoruz (ör: "deneme-yayini-12345"
  const [id, setId] = useState(() => {
    if (!slug) return null;
    const parts = slug.split("-");
    return parts[parts.length - 1]; // Son parçayı ID olarak al
  });
  const { auth } = useContext(AppContext);
  const [pdfDoc, setPdfDoc] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageRef = useRef(currentPage);

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageInput, setPageInput] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(null);
  const mainScrollRef = useRef(null);
  const isScrollingRef = useRef(false);
  const toolbarRef = useRef(null);
  const visitedPagesRef = useRef(new Set());

  const handlePageVisible = useCallback((pageNum) => {
    if (isScrollingRef.current) return;
    setCurrentPage(pageNum);
    setPageInput(pageNum);
  }, []);

  const scrollViewerToElement = (element, smooth = false) => {
    if (!element) return;
    const isFs = !!(document.fullscreenElement || document.webkitFullscreenElement || isFullscreen);
    const scrollBehavior = smooth ? "smooth" : "auto";
    if (isFs && mainScrollRef.current) {
      const topOffset = element.offsetTop;
      mainScrollRef.current.scrollTo({
        top: Math.max(0, topOffset - 20),
        behavior: scrollBehavior,
      });
    } else {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const topOffset = rect.top + scrollTop;
      window.scrollTo({
        top: Math.max(0, topOffset - 85),
        behavior: scrollBehavior,
      });
    }
  };

  const [publicationrestrictionsList, setPublicationrestrictionsList] = useState([]);
  const [minPageDelay, setMinPageDelay] = useState(0);
  const [canChangePage, setCanChangePage] = useState(true);
  const [dailyViewLimit, setDailyViewLimit] = useState(null);
  const [userViewCount, setUserViewCount] = useState(0);
  const [totalDailyViewLimit, setTotalDailyViewLimit] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem("pdf_viewer_theme") === "dark";
  });

  const toggleDarkMode = () => {
    setIsDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem("pdf_viewer_theme", next ? "dark" : "light");
      return next;
    });
  };

  const [showRangePanel, setShowRangePanel] = useState(false);
  const [rangeStart, setRangeStart] = useState("");
  const [rangeEnd, setRangeEnd] = useState("");
  const [isProtected, setIsProtected] = useState(false);
  const [bookmarks, setBookmarks] = useState([]);
  const [publicationtype, setPublicationtype] = useState(null);

  const headers = auth.token ? { Authorization: `Bearer ${auth.token}` } : undefined;

  const [downloading, setDownloading] = useState(false);
  const [downloadingText, setDownloadingText] = useState("");
  const hasBookmarks = bookmarks.length > 0;
  const [parentId, setParentId] = useState(null);
  const [parentPDF, setParentPDF] = useState(null);
  const [parentType, setParentType] = useState(null);

  const [showLcpModal, setShowLcpModal] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [toolbarHeight, setToolbarHeight] = useState(0);
  const mobileIconSize = 24;

  const [countdown, setCountdown] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]); // [{page: 1, text: "..."}, ...]
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);

  // Arama çubuğunun görünürlüğü için yeni bir state
  const [showSearchBar, setShowSearchBar] = useState(false);

  // Sonraki/Önceki eşleşmeye gitme fonksiyonu
  const navigateSearch = (direction) => {
    if (searchResults.length === 0) return;

    let newIndex;
    if (direction === "next") {
      newIndex = (currentSearchIndex + 1) % searchResults.length;
    } else {
      newIndex = (currentSearchIndex - 1 + searchResults.length) % searchResults.length;
    }

    setCurrentSearchIndex(newIndex);
    jumpToPage(searchResults[newIndex].page);
  };

  // Arama çubuğunu kapatma ve temizleme
  const closeSearch = () => {
    setShowSearchBar(false);
    setSearchTerm("");
    setSearchResults([]);
    setCurrentSearchIndex(-1);
  };

  // Geri sayımı ve yönlendirmeyi yöneten useEffect
  useEffect(() => {
    if (countdown === null) return;

    if (countdown === 0) {
      navigate("/login", {
        state: {
          from: location.pathname + location.search
        }
      });
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate, location.pathname, location.search]);

  const normalizeFallbackBookmarks = (fallback) => {
    const raw = Array.isArray(fallback?.data) ? fallback.data : [];
    const data = raw.map((item) => {
      const title = String(item?.title ?? "").replace(/\s*\/$/, "").trim();
      const start = Number(item?.startPage ?? 0) || 0;
      const end = Number(item?.endPage ?? 0) || start || 0;
      const level = Number(item?.level ?? 1) || 1;

      const authorStr = String(item?.author ?? "").trim();
      const authors = authorStr
        ? [{ name: authorStr, surname: "" }]
        : [];


      const wrap = (v) => [{ value: [String(v)] }];

      return {
        level,
        authors,
        publicationtypeInfo: [
          { attributename: "Başlık", value: wrap(title) },
          { attributename: "İlk Sayfa", value: wrap(start) },
          { attributename: "Son Sayfa", value: wrap(end) },
        ],
      };
    });

    return {
      message: String(fallback?.message ?? "OK"),
      status: String(fallback?.status ?? "OK"),
      count: Number(fallback?.count ?? data.length),
      data,
    };
  };


  useEffect(() => {
    if (!toolbarRef.current) return;

    const updateHeight = () => {
      const h = toolbarRef.current.offsetHeight || 0;
      setToolbarHeight(h);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const fetchBookmarks = async () => {
    // Eğer parentId varsa onu, yoksa mevcut id'yi kullan
    const targetId = parentId || id;
    const targetType = parentType || publicationtype;
    console.log(targetId, targetType);

    try {
      const primary = await pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNot(
        targetId,
        targetType,
        auth.token,
        1,
        10000,
        -1
      );

      const primaryData = Array.isArray(primary?.data) ? primary.data : [];
      if (primary?.status === "OK" && primaryData.length > 0) {
        setBookmarks(primaryData);
        return;
      }

      const fallback = await publicationBookMarkList(targetId, auth.token);
      const normalized = normalizeFallbackBookmarks(fallback);

      if (normalized?.status === "OK" && normalized?.count > 0) {
        setBookmarks(normalized.data);
      } else {
        setBookmarks([]);
      }
    } catch (e) {
      console.error("fetchBookmarks error:", e);
      setBookmarks([]);
    }
  };


  useEffect(() => {
    console.log(Boolean(pdfDoc))
    if (pdfDoc) {
      console.log("inside");
      fetchBookmarks();
    }
  }, [pdfDoc, parentId]);


  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.1, 4));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));
  };

  const handleZoomFitWidth = () => {
    if (!pdfDoc) return;
    const scrollWidth = mainScrollRef.current
      ? mainScrollRef.current.clientWidth - 48
      : window.innerWidth - 48;
    pdfDoc.getPage(1).then((page) => {
      const viewport = page.getViewport({ scale: 1 });
      const fitZoom = scrollWidth / viewport.width;
      setZoomLevel(Math.min(Math.max(fitZoom, 0.5), 3.0));
    });
  };

  const handleZoomFitHeight = () => {
    if (!pdfDoc) return;
    // Window height minus header, toolbar heights, and page margins (18px top & 18px bottom) with safety padding
    const scrollHeight = window.innerHeight - 160;
    pdfDoc.getPage(1).then((page) => {
      const viewport = page.getViewport({ scale: 1 });
      const fitZoom = scrollHeight / viewport.height;
      setZoomLevel(Math.min(Math.max(fitZoom, 0.5), 3.0));
    });
  };

  const toggleFullscreen = () => {
    const element = document.getElementById("pdf-viewer-container");

    if (!document.fullscreenElement) {
      element.requestFullscreen().then(() => {
        setIsFullscreen(true);
      }).catch((err) => {
        console.error("Fullscreen modu açılamadı:", err);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      });
    }
  };

  // state'lere ekle
  const [alertsMap, setAlertsMap] = useState({});
  const alertsRef = useRef({});


  // helper
  const getAlert = (title, fallback) => {
    const key = String(title ?? "").trim();
    return alertsRef.current[key] || fallback;
  };


  // directus'tan alert çek
  const getAlerts = async () => {
    try {
      const res = await getPdfAlerts(); // { data: [...] } veya { data: { data: [...] } }
      const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
      const map = list.reduce((acc, { title, content }) => {
        if (title && content) acc[String(title).trim()] = String(content).trim();
        return acc;
      }, {});
      alertsRef.current = map;   // <= kritik
      setAlertsMap(map);         // UI için
    } catch (e) {
      console.error("getAlerts error:", e);
    }
  };


  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFs = !!(document.fullscreenElement || document.webkitFullscreenElement);
      setIsFullscreen(isFs);

      setTimeout(() => {
        const targetPage = currentPageRef.current;
        if (targetPage) {
          const el = document.getElementById(`pdf-page-${targetPage}`);
          if (el) {
            scrollViewerToElement(el, false);
          }
        }
      }, 100);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  const logVisit = async () => {
    try {
      // Sadece kayıt tutar, return ederek sayfayı kapatmaz
      await createPDFLog("publication_view").catch(() => { });
    } catch (err) {
      console.error("Ziyaret log hatası:", err);
    }
  };

  const renderHighlightedText = (text, highlight) => {
    if (!highlight.trim()) return text;
    const parts = text.split(new RegExp(`(${highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));
    return (
      <span>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <strong key={i} style={{ color: '#000', backgroundColor: '#fdf08d', padding: '0 1px', borderRadius: '2px' }}>{part}</strong>
          ) : (
            part
          )
        )}
      </span>
    );
  };

  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (!searchTerm || searchTerm.length < 3 || !pdfDoc) {
      toast.info("Lütfen en az 3 karakter giriniz.");
      return;
    }

    setIsSearching(true);
    const results = [];
    const termLower = searchTerm.toLocaleLowerCase('tr-TR');

    try {
      for (let i = 1; i <= totalPages; i++) {
        const page = await pdfDoc.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map(item => item.str).join(" ");
        const pageTextLower = pageText.toLocaleLowerCase('tr-TR');

        if (pageTextLower.includes(termLower)) {
          // Kelimenin geçtiği ilk indeksi bul ve etrafından bir kesit al
          const startIndex = pageTextLower.indexOf(termLower);
          const previewStart = Math.max(0, startIndex - 40);
          const previewEnd = Math.min(pageText.length, startIndex + searchTerm.length + 60);

          let preview = pageText.substring(previewStart, previewEnd);
          if (previewStart > 0) preview = "..." + preview;
          if (previewEnd < pageText.length) preview = preview + "...";

          results.push({
            page: i,
            preview: preview
          });
        }
      }

      setSearchResults(results);
      if (results.length > 0) {
        setCurrentSearchIndex(0);
        jumpToPage(results[0].page);
      } else {
        toast.info("Kelime bulunamadı.");
      }
    } catch (err) {
      console.error("Arama hatası:", err);
      toast.error("Arama sırasında bir hata oluştu.");
    } finally {
      setIsSearching(false);
    }
  };

  const fetchPDFAccessAndInit = async () => {
    try {
      const response = await axiosInstance.get(
        `publications/search/publicationdetailDTO/${id}/-1`,
        { headers }
      );

      const protectedAccess = response?.data?.data?.protectedaccess;
      setIsProtected(protectedAccess === 1);
      await logVisit();
      // setIsProtected(false);
      setPublicationtype(response?.data?.data?.publicationtype?.subPublicationtypes?.[0]?.name || null);
      if (protectedAccess === 1) {
        await fetchPublicationRestrictions();
      }

      await loadPDF();
    } catch (err) {
      setError("Yayın bilgisi alınırken hata oluştu: " + err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getAlerts();
      await fetchPDFAccessAndInit();
    })();
  }, [id]);

  useEffect(() => {
    visitedPagesRef.current.clear();
  }, [id]);

  useEffect(() => {
    if (!id || !pdfDoc) return;
    const pageNum = Number(currentPage);

    // Only set a log timer if the page has NOT been visited yet
    if (!visitedPagesRef.current.has(pageNum)) {
      const timer = setTimeout(() => {
        // Double check again in case it was marked in between (though rare)
        if (!visitedPagesRef.current.has(pageNum)) {
          visitedPagesRef.current.add(pageNum);
          setVisitedPageLog(id, pageNum, auth.token).catch((err) => {
            console.error("Error logging unique page visit:", pageNum, err);
          });
        }
      }, 600); // 0.60 seconds read delay

      return () => clearTimeout(timer);
    }
  }, [currentPage, id, pdfDoc, auth.token]);



  const fetchPublicationRestrictions = async () => {
    try {
      const response = await axiosInstance.get(
        `publicationrestrictionslist/getPublicationrestrictionsList`,
        { headers }
      );
      setPublicationrestrictionsList(response?.data?.data || []);
    } catch (err) {
      console.error("Kısıtlamalar alınırken hata oluştu:", err);
    }
  };

  const createPDFLog = async (logtype) => {
    try {
      await axiosInstance.get(
        `publicationanduserpdflog/create/${id}/${logtype}`,
        { headers }
      );
    } catch (err) {
      console.error("PDF log oluşturulurken hata oluştu:", err);
    }
  };

  const getPDFLog = async (logtype, filter = "montly") => {
    if (!isProtected) return { status: "OK", count: 1 };
    try {
      const response = await axiosInstance.get(
        `publicationanduserpdflog/getByPublicationIdAndUserIdAndLogTypeFilterCount/${id}/${logtype}/${filter}`,
        { headers }
      );
      return response.data;
    } catch (err) {
      console.error("PDF log alınırken hata oluştu:", err);
    }
  };

  const [initialPage, setInitialPage] = useState(null);

  const loadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `publications/search/publicationdetailDTO/${id}/-1`,
        { headers }
      );

      const pageresponse = await axiosInstance.get(
        `publications/search/publicationdetail/${id}/-1`,
        { headers }
      );

      if (response.data.status === "OK") {
        const publication = response.data.data;

        // PARENT BİLGİSİNİ BURADA SET EDİYORUZ
        if (publication?.parent?.id && publication?.parent?.publicationtype?.name !== "Dergi") {
          setParentId(publication.parent.id);
          setParentPDF(publication.parent.pdfFile)
          setParentType(publication.parent.publicationtype?.subPublicationtypes?.[0]?.name);
        } else {
          setParentId(null);
          setParentPDF(null)
          setParentType(null);
        }

        let pdfFile = publication.pdffile;
        let mysqlId = publication.id;

        // if ((publication?.parent?.bookmarkexport === 1 && !isBookType)) {
        //   pdfFile = publication?.parent?.pdffile;
        //   mysqlId = publication?.parent?.id;
        // setId(publication?.parent?.id);
        // }

        if (pdfFile && mysqlId) {
          const pdfUrl = `publications/pdf/displayFile/${id}`;
          const pdfResponse = await axiosInstance.get(pdfUrl, {
            headers,
            responseType: "arraybuffer",
          });

          if (pdfResponse.status === 204) {
            setWarning(getAlert("204", "Bu yayını görüntülemek için ilgili veritabanına aboneliğiniz bulunamadı"));
            setLoading(false);
            return; // Fonksiyondan çıkıyoruz ki boş veriyi PDF olarak yüklemeye çalışmasın
          }

          const loadingTask = pdfjsLib.getDocument({ data: pdfResponse.data });
          const loadedPdf = await loadingTask.promise;
          setPdfDoc(loadedPdf);
          setTotalPages(loadedPdf.numPages);
          const apiFirstPage = Number(pageresponse?.data?.data?.elasticjson?.publicationtypeInfo?.find(attr => attr.attributename === "İlk Sayfa")?.value[0]?.value[0]);

          if (publication?.parent?.id) {
            setInitialPage(1); // Alt bölümler kendi PDF'inde hep 1'den başlar
          } else {
            setInitialPage(apiFirstPage || 1); // Ana kitap/dergi ise gerçek sayfasından başlar
          }
        } else {
          setError(getAlert("Pdf Bulunamadı", "PDF dosyası bulunamadı."));
        }
      } else {
        setError(getAlert("Yayın Bulunamadı", "Geçerli bir yayın bulunamadı."));
      }
    } catch (err) {
      const status = err?.response?.status ||
        console.warn(err.name);
      if (status === 204) {
        setWarning(getAlert("204", "Bu yayını görüntülemek için ilgili veritabanına aboneliğiniz bulunamadı"));
      } else if (status === 404) {
        setError(getAlert("404", "PDF bulunamadı"));
      } else if (status === 405) {
        setError(getAlert("405", "Bu içeriğe erişim yetkiniz bulunmamaktadır. Lütfen kurumsal e-posta adresinizle giriş yapın veya kurumunuzun IP erişiminin tanımlı olduğundan emin olun."));
        setCountdown(6);
      } else if (status === 500) {
        setError(getAlert("500", "Üzgünüz, bir hata oluştu."));
      } else {
        setError("Üzgünüz, bir hata oluştu.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialPage && pdfDoc) {
      jumpToPage(initialPage);
    }
  }, [initialPage, pdfDoc]);



  useEffect(() => {
    if (!isProtected) return;
    const rightClickRule = publicationrestrictionsList.find(
      (rule) => rule.abbreviation === "right_click_disable" && rule.protectedaccess === "1"
    );

    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(e.key)) ||
        (e.ctrlKey && e.key === "u")
      ) {
        e.preventDefault();
      }
    };

    if (rightClickRule) {
      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [publicationrestrictionsList]);

  // Keyboard navigation (Arrow keys & Zoom shortcuts)
  useEffect(() => {
    const handleNavigationKeyDown = (e) => {
      const targetTag = (e.target?.tagName || "").toLowerCase();
      if (targetTag === "input" || targetTag === "textarea") return;

      if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        e.preventDefault();
        jumpToPage(Math.min(currentPage + 1, totalPages));
      } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
        e.preventDefault();
        jumpToPage(Math.max(currentPage - 1, 1));
      } else if (e.key === "+" || (e.ctrlKey && e.key === "=")) {
        e.preventDefault();
        handleZoomIn();
      } else if (e.key === "-" || (e.ctrlKey && e.key === "-")) {
        e.preventDefault();
        handleZoomOut();
      }
    };
    window.addEventListener("keydown", handleNavigationKeyDown);
    return () => window.removeEventListener("keydown", handleNavigationKeyDown);
  }, [currentPage, totalPages, pdfDoc]);

  useEffect(() => {
    if (!isProtected) return;
    const transitionRule = publicationrestrictionsList.find(
      (rule) => rule.abbreviation === "page_transition_min_time"
    );

    if (transitionRule) {
      const delayInSeconds = parseInt(transitionRule.protectedaccess, 10);
      setMinPageDelay(delayInSeconds > 0 ? delayInSeconds : 0);
    }
  }, [publicationrestrictionsList]);

  useEffect(() => {
    if (!isProtected) return;
    const dailyRule = publicationrestrictionsList.find(
      (r) => r.abbreviation === "page_view_daily"
    );
    if (dailyRule && dailyRule.protectedaccess !== "-1") {
      const percentage = parseFloat(dailyRule.protectedaccess);
      const allowed = Math.ceil((totalPages * percentage) / 100);
      setDailyViewLimit(allowed);
    }
  }, [publicationrestrictionsList, totalPages]);

  useEffect(() => {
    if (!isProtected) return;
    const totalRule = publicationrestrictionsList.find(
      (r) => r.abbreviation === "total_page_view_daily"
    );
    if (totalRule && totalRule.protectedaccess !== "-1") {
      setTotalDailyViewLimit(parseInt(totalRule.protectedaccess, 10));
    }
  }, [publicationrestrictionsList]);

  useEffect(() => {
    if (!isProtected || !pdfDoc) return;
    const fetchLogCount = async () => {
      const logData = await getPDFLog("page_view");
      if (logData?.status === "OK") {
        setUserViewCount(parseInt(logData.count || "0", 10));
      }
    };
    if (pdfDoc) {
      fetchLogCount();
    }
  }, [pdfDoc]);

  useEffect(() => {
    setPageInput(currentPage);
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const handlePageSubmit = () => {
    let target = parseInt(pageInput, 10);
    if (isNaN(target) || target < 1) {
      setPageInput(currentPage);
      return;
    }
    if (target > totalPages) {
      target = totalPages;
    }
    setPageInput(target);
    jumpToPage(target);
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === "Enter") {
      handlePageSubmit();
      e.target.blur();
    }
  };

  const handlePageInputBlur = () => {
    handlePageSubmit();
  };

  const handlePageChange = async (direction) => {
    if (!canChangePage) return;

    const nextPage =
      direction === "next"
        ? Math.min(currentPage + 1, totalPages)
        : Math.max(currentPage - 1, 1);

    if (nextPage === currentPage) return;

    // Sayfa değişimini anında yap (Hata olsa da olmasa da)
    setCurrentPage(nextPage);
    setPageInput(nextPage);

    isScrollingRef.current = true;
    const element = document.getElementById(`pdf-page-${nextPage}`);
    if (element) {
      scrollViewerToElement(element);
      setTimeout(() => {
        isScrollingRef.current = false;
      }, 800);
    }

    // Loglama işlemini arka planda sessizce yap
    if (isProtected) {
      createPublicationPdfLog(id, nextPage, auth.token).catch(() => { });
      createPDFLog("page_view").catch(() => { });
    }

    // Debounce için kısa bir kilit
    setCanChangePage(false);
    setTimeout(() => setCanChangePage(true), 150);
  };

  const handleDownloadPublication = async () => {
    if (!auth.token) {
      setShowLoginModal(true);
      return;
    }

    setDownloading(true);
    const logDaily = await getPDFLog("publication_download", "daily");
    const logmontly = await getPDFLog("publication_download", "montly");

    const pubRuleDaily = publicationrestrictionsList.find(r => r.abbreviation === "publication_download_daily");
    if (pubRuleDaily && pubRuleDaily.protectedaccess !== "-1") {
      const allowed = parseInt(pubRuleDaily.protectedaccess, 10);
      const count = parseInt(logDaily?.count || "0", 10);
      const already = logDaily?.data?.ids?.includes(parseInt(id));
      if (count >= allowed && !already) {
        setError("Günlük yayın indirme limitinizi aştınız.");
        return;
      }
    }

    const pubRulemontly = publicationrestrictionsList.find(r => r.abbreviation === "publication_download_monthly");
    if (pubRulemontly && pubRulemontly.protectedaccess !== "-1") {
      const allowed = parseInt(pubRulemontly.protectedaccess, 10);
      const count = parseInt(logmontly?.count || "0", 10);
      const already = logmontly?.data?.ids?.includes(parseInt(id));
      if (count >= allowed && !already) {
        setError("Aylık yayın indirme limitinizi aştınız.");
        return;
      }
    }

    const totalDaily = publicationrestrictionsList.find(r => r.abbreviation === "total_page_download_daily");
    if (totalDaily && totalDaily.protectedaccess !== "-1") {
      const allowed = parseInt(totalDaily.protectedaccess, 10);
      const downloaded = parseInt(logDaily?.count || "0", 10);
      if (downloaded >= allowed) {
        setError("Sistem genelindeki günlük indirme limitinizi aştınız.");
        return;
      }
    }

    const totalmontly = publicationrestrictionsList.find(r => r.abbreviation === "total_page_download_monthly");
    if (totalmontly && totalmontly.protectedaccess !== "-1") {
      const allowed = parseInt(totalmontly.protectedaccess, 10);
      const downloaded = parseInt(logmontly?.count || "0", 10);
      if (downloaded >= allowed) {
        setError("Sistem genelindeki aylık indirme limitinizi aştınız.");
        return;
      }
    }

    try {
      // 1. DRM API'den JSON verisini çekiyoruz
      const drmRes = await axiosInstance.get(`publications/DRM/downloadFile/${id}`, { headers });
      const lcplData = drmRes.data;

      // 2. JSON verisini dosyaya dönüştürüyoruz
      const blob = new Blob([JSON.stringify(lcplData, null, 2)], { type: "application/vnd.readium.lcp.license.v1.0+json" });
      const url = window.URL.createObjectURL(blob);

      // 3. Görünmez bir link oluşturup tetikliyoruz
      const link = document.createElement('a');
      link.href = url;
      link.download = `yayin-${id}.lcpl`; // Uzantı MUTLAKA .lcpl olmalı
      document.body.appendChild(link);
      link.click();

      // 4. Temizlik
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setShowLcpModal(true);
    } catch (err) {
      console.error(err);
      toast.error("Dosya hazırlanırken bir hata oluştu.");
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    if (
      location.state?.autoDownload &&
      auth?.token &&
      !loading &&
      pdfDoc &&
      !autoDownloadHandledRef.current
    ) {
      autoDownloadHandledRef.current = true;
      navigate(location.pathname + location.search, { replace: true, state: {} });
      handleDownloadPublication();
    }
  }, [location.state, auth?.token, loading, pdfDoc, navigate, location.pathname, location.search]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      const tag = (e.target?.tagName || "").toLowerCase();
      if (e.target?.isContentEditable || ["input", "textarea", "select"].includes(tag)) return;

      if (e.key === "ArrowRight") {
        e.preventDefault();
        handlePageChange("next");
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        handlePageChange("prev");
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handlePageChange]);

  const isBookmarkActive = (bm) => {
    // 1. Durum: ID Eşleşmesi (Bölüm PDF'i açılmışsa en sağlıklı yöntem budur)
    // bookmark içindeki ID ile o an URL'de olan ID eşleşiyor mu?
    const isIdMatch = bm.mysqlId && String(bm.mysqlId) === String(id);

    console.log(bm);

    // 2. Durum: Sayfa Aralığı (Önizleme/Ana PDF modundayken gereklidir)
    const startPage = Number(bm.publicationtypeInfo?.find(attr => attr.attributename === "İlk Sayfa")?.value[0]?.value[0]) || Number(bm.templateInfo?.find(attr => attr.attributename === "İlk Sayfa")?.value[0]?.value[0]);
    const endPage = Number(bm.publicationtypeInfo?.find(attr => attr.attributename === "Son Sayfa")?.value[0]?.value[0]) || Number(bm.templateInfo?.find(attr => attr.attributename === "Son Sayfa")?.value[0]?.value[0]);
    const isPageInRange = currentPage >= startPage && currentPage <= endPage;

    // Eğer ID eşleşiyorsa VEYA (ID yoksa ve sayfa aralığındaysa) aktif sayılır
    return isIdMatch || (isPageInRange && !parentId);
  };

  const indentPx = (level) => Math.min(Math.max((Number(level) || 1) - 1, 0) * 14, 56);

  const jumpToPage = async (targetPage, endPage, newPublicationId) => {
    if (!pdfDoc) return;

    if (targetPage < 1) {
      toast.warning(`Sayfa bulunamadı: ${targetPage}`);
      return;
    }

    const currentId = id;
    const targetId = newPublicationId ? String(newPublicationId) : null;
    const finalPageOfSection = endPage || targetPage;

    if (parentId) {
      if (targetId && targetId !== currentId) {
        window.location.href = `/view-pdf-protectedaccess/${targetId}`;
        return;
      }
    }

    // Bölümün tamamı mevcut PDF sınırları içinde mi?
    const isSectionFullyAvailable = targetPage >= 1 && finalPageOfSection <= totalPages;

    if (isSectionFullyAvailable) {
      setCurrentPage(targetPage);
      setPageInput(targetPage);

      isScrollingRef.current = true;
      const element = document.getElementById(`pdf-page-${targetPage}`);
      if (element) {
        scrollViewerToElement(element, false);
        setTimeout(() => {
          isScrollingRef.current = false;
        }, 150);
      }

      // Arka plan loglama
      if (isProtected) {
        createPublicationPdfLog(currentId, targetPage, auth.token).catch(() => { });
        createPDFLog("page_view").catch(() => { });
      }
    }
    // Eğer farklı bir ID gerekiyorsa yönlendir
    else if (newPublicationId && String(newPublicationId) !== String(currentId)) {
      window.location.href = `/view-pdf-protectedaccess/${newPublicationId}`;
    }
  };

  const [isBookmarksOpen, setIsBookmarksOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {

      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", padding: "20px" }}>
        <div className="card shadow-lg border-danger text-center" style={{ maxWidth: "500px", width: "100%" }}>
          <div className="card-header bg-danger text-white fw-bold fs-5">
            Bilgilendirme
          </div>
          <div className="card-body">
            <p className="card-text fs-5 text-danger fw-bold">{error}</p>

            {/* GERİ SAYIM GÖSTERGESİ */}
            {countdown !== null && (
              <div className="mt-3 p-2 bg-light rounded border">
                <p className="mb-0 fw-semibold text-dark">
                  Giriş sayfasına yönlendiriliyorsunuz... {countdown}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (warning) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", padding: "20px" }}>
        <div className="card shadow-lg border-warning text-center" style={{ maxWidth: "500px", width: "100%" }}>
          <div className="card-header bg-warning text-white fw-bold fs-5">
            Bilgilendirme
          </div>
          <div className="card-body">
            <p className="card-text fs-5 text-dark fw-semibold">{warning}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div
        id="pdf-viewer-container"
        className="text-center"
        style={isFullscreen ? {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: isDarkMode ? "#121214" : "#525659",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          padding: 0,
          margin: 0,
          transition: "background-color 0.3s ease"
        } : {
          padding: "25px",
          backgroundColor: isDarkMode ? "#121214" : undefined,
          minHeight: "100vh",
          transition: "background-color 0.3s ease"
        }}
      >
        {!isMobile && (
          <div
            ref={toolbarRef}
            className="col-12"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1040,
              padding: "10px 20px"
            }}
          >
            <div className={isDarkMode ? "pdf-toolbar pdf-toolbar-dark" : "pdf-toolbar"}>
              {/* Group 1: Navigation */}
              <div className="pdf-toolbar-group">
                <button onClick={() => window.location.href = "/"} title="Ana Sayfa">
                  <i className='bx bx-home'></i>
                </button>
              </div>

              {/* Group 2: Zoom Controls */}
              <div className="pdf-toolbar-group">
                <button onClick={handleZoomOut} title="Uzaklaştır">
                  <i className='bx bx-zoom-out'></i>
                </button>
                <div className="zoom-text">{Math.round(zoomLevel * 100)}%</div>
                <button onClick={handleZoomIn} title="Yakınlaştır">
                  <i className='bx bx-zoom-in'></i>
                </button>
                <div className="vr bg-secondary opacity-25 mx-1" style={{ height: "18px" }}></div>
                <button onClick={handleZoomFitWidth} title="Genişliğe Sığdır">
                  <i className='bx bx-expand-horizontal'></i>
                </button>
                <button onClick={handleZoomFitHeight} title="Ekrana Sığdır">
                  <i className='bx bx-expand-vertical'></i>
                </button>
              </div>

              {/* Group 3: Page Navigation */}
              <div className="pdf-toolbar-group">
                <div className="page-info gap-1 px-1">
                  <span>Sayfa</span>
                  <input
                    type="number"
                    min={1}
                    max={totalPages}
                    value={pageInput}
                    onChange={handlePageInputChange}
                    onKeyDown={handlePageInputKeyDown}
                    onBlur={handlePageInputBlur}
                    style={{
                      width: "46px",
                      height: "32px",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "600",
                      borderRadius: "6px",
                      border: "1px solid #cbd5e1",
                      boxSizing: "border-box"
                    }}
                  />
                  <span>/ {totalPages}</span>
                </div>
              </div>

              {/* Group 4: Actions */}
              <div className="pdf-toolbar-group">
                <button
                  onClick={handleDownloadPublication}
                  disabled={downloading}
                  title="İndir"
                  style={{ minWidth: "32px" }}
                >
                  {downloading ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      role="status"
                      style={{ width: "1rem", height: "1rem", color: "inherit" }}
                    />
                  ) : (
                    <i className='bx bxs-download'></i>
                  )}
                </button>

                <button onClick={toggleFullscreen} title={isFullscreen ? "Fullscreen'den Çık" : "Fullscreen'e Geç"}>
                  <i className={isFullscreen ? "bx bx-exit-fullscreen" : "bx bx-fullscreen"}></i>
                </button>

                <button onClick={toggleDarkMode} title={isDarkMode ? "Aydınlık Mod" : "Karanlık Mod"}>
                  <i className={isDarkMode ? "bx bx-sun text-warning" : "bx bx-moon"}></i>
                </button>

                <button onClick={() => setShowSearchBar(true)} title="Kelime Ara">
                  <i className='bx bx-search'></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {isMobile && (
          <div
            ref={toolbarRef}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1040,
              background: isDarkMode ? "rgba(30, 30, 36, 0.95)" : "rgba(255,255,255)",
              backdropFilter: "blur(8px)",
              borderBottom: isDarkMode ? "1px solid #3f3f46" : "1px solid rgba(0,0,0,0.08)",
              padding: "8px 10px",
              transition: "background-color 0.3s ease"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8
              }}
            >
              {/* SOL */}
              <div className="pdf-toolbar-group">
                <button onClick={() => window.location.href = "/"} title="Ana Sayfa">
                  <i className='bx bx-home'></i>
                </button>
                <button onClick={handleZoomOut} title="Uzaklaştır">
                  <i className='bx bx-zoom-out'></i>
                </button>
              </div>

              {/* ORTA */}
              <div className="pdf-toolbar-group">
                <div className="page-info gap-1 px-1">
                  <input
                    type="number"
                    min={1}
                    max={totalPages}
                    value={pageInput}
                    onChange={handlePageInputChange}
                    onKeyDown={handlePageInputKeyDown}
                    onBlur={handlePageInputBlur}
                    style={{
                      width: "42px",
                      height: "32px",
                      textAlign: "center",
                      fontSize: "13px",
                      borderRadius: "6px",
                      border: "1px solid #cbd5e1",
                      boxSizing: "border-box"
                    }}
                  />
                  <span>/ {totalPages}</span>
                </div>
              </div>

              {/* SAĞ */}
              <div className="pdf-toolbar-group">
                <button onClick={handleZoomIn} title="Yakınlaştır">
                  <i className="bx bx-zoom-in" />
                </button>

                <button onClick={handleZoomFitWidth} title="Genişliğe Sığdır">
                  <i className="bx bx-expand-horizontal" />
                </button>

                <button onClick={handleZoomFitHeight} title="Ekrana Sığdır">
                  <i className="bx bx-expand-vertical" />
                </button>

                <button onClick={toggleFullscreen} title={isFullscreen ? "Fullscreen'den Çık" : "Fullscreen'e Geç"}>
                  <i className="bx bx-fullscreen" />
                </button>

                <button onClick={toggleDarkMode} title={isDarkMode ? "Aydınlık Mod" : "Karanlık Mod"}>
                  <i className={isDarkMode ? "bx bx-sun text-warning" : "bx bx-moon"} />
                </button>
              </div>
            </div>
          </div>
        )}
        {showSearchBar && (
          <div
            style={{
              position: "fixed",
              top: isMobile ? "70px" : "85px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1100,
              width: isMobile ? "90%" : "450px",
              background: isDarkMode ? "rgba(30, 30, 36, 0.95)" : "rgba(255, 255, 255, 0.95)",
              color: isDarkMode ? "#f1f5f9" : undefined,
              backdropFilter: "blur(10px)",
              padding: "10px 15px",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              border: isDarkMode ? "1px solid #3f3f46" : "1px solid rgba(0,0,0,0.08)",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <div style={{ flex: 1, position: "relative" }}>
              <Form.Control
                autoFocus
                placeholder="Kelime ara..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  if (searchResults.length > 0) {
                    setSearchResults([]);
                    setCurrentSearchIndex(-1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (searchResults.length > 0) {
                      navigateSearch("next");
                    } else {
                      handleSearch(e);
                    }
                  }
                  if (e.key === "Escape") closeSearch();
                }}
                style={{
                  border: "none",
                  background: "transparent",
                  color: isDarkMode ? "#f1f5f9" : undefined,
                  boxShadow: "none",
                  paddingRight: "40px"
                }}
              />
              {isSearching && (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ position: "absolute", right: "10px", top: "10px", color: isDarkMode ? "#aaa" : "#666" }}
                />
              )}
            </div>

            {searchResults.length > 0 && (
              <div style={{ display: "flex", alignItems: "center", gap: "5px", borderLeft: isDarkMode ? "1px solid #3f3f46" : "1px solid #ddd", paddingLeft: "10px" }}>
                <span style={{ fontSize: "12px", fontWeight: "600", minWidth: "45px", color: isDarkMode ? "#e2e8f0" : undefined }}>
                  {currentSearchIndex + 1} / {searchResults.length}
                </span>
                <button
                  onClick={() => navigateSearch("prev")}
                  style={{ background: "none", border: "none", color: isDarkMode ? "#e2e8f0" : "#333" }}
                >
                  <FeatherIcon icon="chevron-up" size={18} />
                </button>
                <button
                  onClick={() => navigateSearch("next")}
                  style={{ background: "none", border: "none", color: isDarkMode ? "#e2e8f0" : "#333" }}
                >
                  <FeatherIcon icon="chevron-down" size={18} />
                </button>
              </div>
            )}

            <button
              onClick={closeSearch}
              style={{ background: "none", border: "none", color: "#ff4d4f", marginLeft: "5px" }}
            >
              <FeatherIcon icon="x" size={20} />
            </button>
          </div>
        )}
        <div
          className={isFullscreen ? "d-flex w-100 flex-row" : "row justify-content-center"}
          style={isFullscreen ? { flex: 1, minHeight: 0, overflow: "hidden", position: "relative" } : undefined}
        >
          {hasBookmarks && (
            <>
              <aside
                style={{
                  position: "fixed",
                  top: isFullscreen ? (toolbarHeight || 56) : 0,
                  left: 0,
                  height: isFullscreen ? `calc(100vh - ${toolbarHeight || 56}px)` : "100vh",
                  width: isMobile ? "75%" : 400, // İsteğin üzerine %75 yapıldı
                  background: isDarkMode ? "rgba(24, 24, 28, 0.96)" : "rgba(247, 245, 245, 0.86)",
                  backdropFilter: "blur(8px)",
                  borderRight: isDarkMode ? "1px solid #3f3f46" : "1px solid rgba(0,0,0,0.06)",
                  borderRadius: isMobile ? "0" : "0 20px 20px 0",
                  boxShadow: isDarkMode ? "8px 0 24px rgba(0,0,0,0.5)" : "8px 0 24px rgba(0,0,0,0.08)",
                  transform: isBookmarksOpen ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 0.3s cubic-bezier(.4,0,.2,1), background-color 0.3s ease",
                  zIndex: 1050,
                  overflowY: "auto",
                  padding: "16px 14px"
                }}
              >

                <div className={isDarkMode ? "text-lg text-white" : "text-lg text-newdarkfume"} style={{ fontWeight: 700, marginBottom: 10 }}>
                  Bölüm Listesi
                </div>
                <div className={isDarkMode ? "text-md text-light" : "text-md text-newdarkfume"} style={{ fontWeight: 700, marginBottom: 10 }}>
                  { }
                </div>
                <hr className="mb-4" style={{ borderColor: isDarkMode ? "#3f3f46" : undefined }} />
                {(parentId && parentPDF) && (
                  <div
                    onClick={() => {
                      if (String(parentId) !== String(id)) {
                        window.location.href = `/view-pdf-protectedaccess/${parentId}`;
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      borderRadius: 8,
                      padding: "10px 12px",
                      marginBottom: 12,
                      background: isDarkMode ? "#27272a" : "#f8fafc",
                      border: isDarkMode ? "1px solid #3f3f46" : "1px solid #cbd5e1",
                      color: isDarkMode ? "#f1f5f9" : undefined,
                      fontWeight: 700,
                      textAlign: "center"
                    }}
                  >
                    <i className="bx bx-book-open me-1" />
                    Tam PDF / Önizleme
                  </div>
                )}

                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {bookmarks.map((bm, idx) => {
                    const start = Number(
                      bm.publicationtypeInfo?.find(a => a.attributename === "İlk Sayfa")
                        ?.value[0]?.value[0] || bm.templateInfo?.find(a => a.attributename === "İlk Sayfa")
                          ?.value[0]?.value[0] || 0
                    );
                    const end = Number(
                      bm.publicationtypeInfo?.find(a => a.attributename === "Son Sayfa")
                        ?.value[0]?.value[0] || bm.templateInfo?.find(a => a.attributename === "Son Sayfa")
                          ?.value[0]?.value[0] || 0
                    );
                    const active = isBookmarkActive(bm);

                    return (
                      <li
                        key={idx}
                        onClick={() => jumpToPage(start, end, bm.mysqlId || bm.id)}
                        style={{
                          padding: "10px 12px",
                          marginBottom: 6,
                          borderRadius: 10,
                          cursor: "pointer",
                          background: active ? (isDarkMode ? "linear-gradient(90deg,#0284c7,#0369a1)" : "linear-gradient(90deg,#e0f2fe,#f0f9ff)") : "transparent",
                          border: active ? "1px solid #38bdf8" : (isDarkMode ? "1px solid #334155" : "1px solid #e6e6e6b9"),
                          color: isDarkMode ? (active ? "#fff" : "#e2e8f0") : undefined,
                          transition: "all .2s ease"
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.background = active
                            ? (isDarkMode ? "linear-gradient(90deg,#0284c7,#0369a1)" : "linear-gradient(90deg,#e0f2fe,#f0f9ff)")
                            : (isDarkMode ? "#27272a" : "#f8fafc");
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.background = active
                            ? (isDarkMode ? "linear-gradient(90deg,#0284c7,#0369a1)" : "linear-gradient(90deg,#e0f2fe,#f0f9ff)")
                            : "transparent";
                        }}
                      >
                        <div style={{ fontSize: 14, fontWeight: active ? 700 : 500, color: isDarkMode ? (active ? "#fff" : "#f1f5f9") : undefined }}>
                          {(function(){
                             const bmTitle = bm.publicationtypeInfo?.find(a => a.attributename === "Başlık")?.value[0]?.value[0] || "—";
                             return typeof bmTitle === 'string' ? bmTitle.replace(/\s*\/$/, '').trim() : bmTitle;
                          })()}
                        </div>
                        <div style={{ fontSize: 11, color: isDarkMode ? "#94a3b8" : "#64748b" }}>
                          Sayfa {start}{end ? ` – ${end}` : ""}
                        </div>
                      </li>

                    );
                  })}
                </ul>
                <div
                  onClick={() => setIsBookmarksOpen(prev => !prev)}
                  style={{
                    position: "absolute",
                    right: "-32px", // Panelin dışına taşırır
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "64px",
                    background: isDarkMode ? "rgba(39, 39, 42, 0.95)" : "rgba(255,255,255,0.92)",
                    color: isDarkMode ? "#e2e8f0" : undefined,
                    backdropFilter: "blur(8px)",
                    border: isDarkMode ? "1px solid #3f3f46" : "1px solid rgba(0,0,0,0.06)",
                    borderLeft: "none", // Panelle birleşmiş gibi görünür
                    borderRadius: "0 12px 12px 0",
                    boxShadow: "4px 0 12px rgba(0,0,0,0.05)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 1200,
                    transition: "all 0.2s ease"
                  }}
                >
                  <FeatherIcon
                    icon={isBookmarksOpen ? "chevron-left" : "chevron-right"}
                    size={20}
                    className={isDarkMode ? "text-light" : "text-muted"}
                  />
                </div>
              </aside>

              {/* Panel Kenarındaki Aç/Kapat Kulpu (Aside Dışında) */}
              <div
                onClick={() => setIsBookmarksOpen(!isBookmarksOpen)}
                style={{
                  position: "fixed",
                  left: isBookmarksOpen ? (isMobile ? "75%" : "400px") : "0px",
                  top: isFullscreen ? `calc(${toolbarHeight || 56}px + 50vh)` : "50%",
                  transform: "translateY(-50%)",
                  width: isMobile ? "38px" : "42px",
                  height: isMobile ? "40px" : "60px",
                  background: isDarkMode ? "rgba(39, 39, 42, 0.95)" : "rgba(239, 239, 239, 0.91)",
                  color: isDarkMode ? "#e2e8f0" : undefined,
                  border: isDarkMode ? "1px solid #3f3f46" : "1px solid rgba(0,0,0,0.1)",
                  borderLeft: "none",
                  borderRadius: "0 12px 12px 0",
                  boxShadow: "4px 0 15px rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 1060,
                  transition: "left 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background 0.2s",
                }}
                className="drawer-handle"
              >
                <FeatherIcon
                  icon={isBookmarksOpen ? "chevron-left" : "list"}
                  size={20}
                />
              </div>
            </>
          )}

          <div
            ref={mainScrollRef}
            style={{
              width: "100%",
              height: isFullscreen ? "100%" : undefined,
              overflow: isFullscreen ? "auto" : undefined,
              marginLeft: !isMobile && hasBookmarks && isBookmarksOpen ? 400 : 0,
              paddingTop: isMobile ? toolbarHeight : 0,
              transition: "margin-left 0.3s ease"
            }}
          >
            <div
              className="d-flex flex-column align-items-center mx-auto"
              style={{ width: "fit-content", minWidth: "100%" }}
            >
              {pdfDoc && Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
                <PDFPage
                  key={pageNum}
                  pageNumber={pageNum}
                  pdfDoc={pdfDoc}
                  zoomLevel={zoomLevel}
                  rotation={0}
                  searchTerm={searchTerm}
                  onVisible={handlePageVisible}
                  isDarkMode={isDarkMode}
                />
              ))}
            </div>
          </div>
        </div>
        {/* GİRİŞ GEREKLİ MODALI */}
        <Modal
          show={showLoginModal}
          onHide={() => setShowLoginModal(false)}
          centered
          backdrop="static" // Dışarı basınca kapanmayı engeller
          keyboard={false}  // ESC tuşu ile kapanmayı engeller
        >
          <Modal.Header className="border-0 pb-0 justify-content-center">
            <div className="text-center mt-3">
              <FeatherIcon icon="user-plus" className="text-warning mb-2" size={48} />
              <Modal.Title className="fs-5 fw-bold text-newdarkfume d-block">
                Profil Oluşturmanız Gerekiyor
              </Modal.Title>
            </div>
          </Modal.Header>

          <Modal.Body className="text-center px-4">
            <p className="text-muted">
              Bu yayını indirebilmek için kurumsal e-postanız ile profil oluşturarak giriş yapmanız gerekmektedir.
            </p>
          </Modal.Body>

          <Modal.Footer className="border-0 pb-4 px-4 flex-column">
            <Button
              variant="primary"
              className="w-100 py-2 fw-bold mb-2"
              style={{ borderRadius: "10px" }}
              onClick={() => {
                setShowLoginModal(false);
                navigate("/login", {
                  state: {
                    from: location.pathname + location.search,
                    autoDownload: true
                  }
                });
              }}
            >
              Giriş Yap / Kayıt Ol
            </Button>
            <Button
              variant="outline-primary"
              className="w-100 text-darkfume text-decoration-none small"
              onClick={() => setShowLoginModal(false)}
            >
              Atla
            </Button>
          </Modal.Footer>
        </Modal>
        {/* LCP Lisans Anahtarı Modalı */}
        <Modal
          show={showLcpModal}
          onHide={() => setShowLcpModal(false)}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fs-5 fw-bold text-newdarkfume">
              <FeatherIcon icon="download-cloud" className="me-2 text-primary" size={22} />
              İndirme Başlatıldı
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: "#f9f9fb", padding: "24px" }}>
            <div className="text-center mb-4">
              <p className="text-muted small mb-0">
                Yayını okuyucu uygulamanızda (Thorium, Aldiko vb.) açmak için aşağıdaki <strong className="text-dark">LCP Şifresini</strong> kullanmalısınız.
              </p>
            </div>

            {/* Şifre Alanı */}
            <InputGroup className="mb-4 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
              <Form.Control
                type={showPass ? "text" : "password"}
                value={auth?.lcppass || ""}
                readOnly
                className="bg-white border-0 text-center"
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  letterSpacing: showPass ? "normal" : "0.3rem",
                }}
              />
              <Button
                variant="outline-primary"
                className="bg-white border-0 px-3"
                onClick={() => setShowPass(!showPass)}
              >
                <FeatherIcon icon={showPass ? "eye-off" : "eye"} size={18} />
              </Button>
              <Button
                variant="primary"
                className="px-3"
                onClick={() => {
                  navigator.clipboard.writeText(auth.lcppass);
                  toast.success("Şifre kopyalandı!");
                }}
              >
                <FeatherIcon icon="copy" size={18} />
              </Button>
            </InputGroup>

            {/* Bilgi Notu */}
            <div
              className="alert alert-info d-flex align-items-start border-0 mb-0"
              style={{ borderRadius: "10px", fontSize: "12px", background: "rgba(13, 110, 253, 0.08)", color: "#055160" }}
            >
              <FeatherIcon icon="info" className="me-2 mt-1 flex-shrink-0" size={14} />
              <div>
                Bu şifre size özeldir ve yayını şifrelemek için kullanılır. İndirdiğiniz yayını DRM destekli okuyucularda açmak için bu anahtarı kullanmalısınız. Güvenliğiniz için şifrenizi <strong>paylaşmayınız</strong>.
              </div>
            </div>




          </Modal.Body>

          <div className="text-center mb-3 p-2" style={{ background: "#fff", borderRadius: "10px", border: "1px dashed #dee2e6" }}>
            <p className="small text-muted mb-1"> Yayını açmak ve kesintisiz bir okuma deneyimi için aşağıdaki bağlantılardan size uygun olanı seçerek "Thorium Reader" uygulamasını indirin.</p>
          </div>

          {/* Thorium İndirme Linkleri - 3'lü Yan Yana Yapı */}
          <div className="bg-white p-3 border rounded-3 shadow-sm mb-4">
            <h6 className="fw-bold mb-3 text-center border-bottom pb-2" style={{ fontSize: "14px", color: "#333" }}>
              Thorium Reader
            </h6>

            <div className="row text-center g-0">
              {/* Windows Sütunu */}
              <div className="col-4 border-end">
                <div className="fw-bold mb-2 small" style={{ color: "#333" }}>Windows</div>
                <a
                  href="https://github.com/edrlab/thorium-reader/releases/download/v3.3.0/Thorium.Setup.3.3.0.exe"
                  className="d-block text-primary text-decoration-none fw-semibold"
                  style={{ fontSize: "13px" }}
                >
                  İndir
                </a>
              </div>

              {/* macOS Sütunu */}
              <div className="col-4 border-end">
                <div className="fw-bold mb-2 small" style={{ color: "#333" }}>Mac</div>
                <a
                  href="https://github.com/edrlab/thorium-reader/releases/download/v3.3.0/Thorium-3.3.0-arm64.dmg"
                  className="d-block text-primary text-decoration-none fw-semibold mb-1"
                  style={{ fontSize: "12px" }}
                >
                  Apple Silicon <br /> (M1,2,3,4)
                </a>
                <a
                  href="https://github.com/edrlab/thorium-reader/releases/download/v3.3.0/Thorium-3.3.0.dmg"
                  className="d-block text-primary text-decoration-none fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Intel
                </a>
              </div>

              {/* Linux Sütunu */}
              <div className="col-4">
                <div className="fw-bold mb-2 small" style={{ color: "#333" }}>Linux</div>
                <a
                  href="https://github.com/edrlab/thorium-reader/releases/download/v3.3.0/Thorium-3.3.0.AppImage"
                  className="d-block text-primary text-decoration-none fw-semibold mb-1"
                  style={{ fontSize: "12px" }}
                >
                  AppImage
                </a>
                <a
                  href="https://github.com/edrlab/thorium-reader/releases/download/v3.3.0/EDRLab.ThoriumReader_3.3.0_amd64.deb"
                  className="d-block text-primary text-decoration-none fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Debian (.deb)
                </a>
              </div>
            </div>
          </div>

          <Modal.Footer className="border-0 pt-0">
            <Button
              variant="outline-primary"
              className="w-100 py-2 fw-bold"
              style={{ borderRadius: "10px" }}
              onClick={() => setShowLcpModal(false)}
            >
              Anladım, Kapat
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </div>
  );
};

export default PDFViewer;
